// src/stone/illustrations/QrCodeSquareIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var QrCodeSquareIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M43.915 27.098h-6.157a.83.83 0 0 1-.834-.833v-6.148a.83.83 0 0 1 .834-.833h6.157a.83.83 0 0 1 .835.833v6.148c0 .453-.371.833-.835.833M39.677 39.521h-2.05a.273.273 0 0 1-.277-.277v-2.046c0-.158.12-.278.278-.278h2.049c.158 0 .278.12.278.278v2.046c0 .157-.12.277-.278.277M39.677 44.733h-2.05a.273.273 0 0 1-.277-.277V42.41c0-.158.12-.278.278-.278h2.049c.158 0 .278.12.278.278v2.046c0 .157-.12.277-.278.277M44.898 39.521h-2.05a.273.273 0 0 1-.278-.277v-2.046c0-.158.12-.278.279-.278h2.049c.157 0 .278.12.278.278v2.046c0 .157-.12.277-.278.277M42.292 42.132h-2.049a.273.273 0 0 1-.278-.278v-2.046c0-.157.12-.278.278-.278h2.05c.157 0 .277.12.277.278v2.046c0 .148-.13.278-.278.278M25.935 44.734h-6.157a.83.83 0 0 1-.835-.834v-6.147a.83.83 0 0 1 .835-.833h6.157a.83.83 0 0 1 .834.833V43.9a.83.83 0 0 1-.834.834M25.935 27.098h-6.157a.83.83 0 0 1-.835-.833v-6.148a.83.83 0 0 1 .835-.833h6.157a.83.83 0 0 1 .834.833v6.148c0 .453-.37.833-.834.833M49.673 33.393H14.336a1.388 1.388 0 1 1 0-2.778h35.337a1.388 1.388 0 1 1 0 2.778"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M32 51.029c-.77 0-1.39-.62-1.39-1.39V14.36c0-.769.62-1.39 1.39-1.39s1.391.621 1.391 1.39v35.28c0 .77-.621 1.39-1.39 1.39"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M47.994 51.038h-31.99a3.07 3.07 0 0 1-3.069-3.064V16.025a3.07 3.07 0 0 1 3.07-3.064h31.99a3.07 3.07 0 0 1 3.068 3.064v31.949a3.07 3.07 0 0 1-3.069 3.064m-31.99-35.29a.29.29 0 0 0-.287.287v31.948c0 .158.13.287.288.287h31.99c.157 0 .287-.13.287-.287V16.035a.29.29 0 0 0-.288-.287z"
        }
      )
    ]
  }
);
var QrCodeSquareIllustration_default = QrCodeSquareIllustration;

export {
  QrCodeSquareIllustration_default
};
